import { Link } from 'gatsby';
import * as React from 'react';
import styled from 'styled-components';
import { pages } from '../../../../config';
import StoreContext from '../../../contexts/StoreContext';
import CartIcon from './images/cart.inline.svg';
import EmptyCartIcon from './images/empty-cart.inline.svg';

const StyledLink = styled(Link)`
  position: relative;

  svg {
    display: none;
  }

  @media (min-width: 992px) {
    svg {
      display: block;
    }
  }
`;

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  margin-left: 5px;
  padding: 0 5px;
  line-height: 1;
  font-weight: 700;
  color: var(--earth-fm--color--green);
  background-color: var(--earth-fm--color--light-orange);
  border-radius: 11px;

  @media (min-width: 992px) {
    position: absolute;
    top: -10px;
    right: -10px;
    border: 2px solid var(--earth-fm--color--beige);
  }
`;

const ButtonText = styled.span`
  @media (min-width: 992px) {
    display: none;
  }
`;

export default function CartButton() {
  const { checkout } = React.useContext(StoreContext);
  const quantity = checkout?.lineItems.reduce((total, item) => total + item.quantity, 0) ?? 0;

  return (
    <StyledLink
      to={pages.cart}
      aria-label={
        quantity === 1 ? `${quantity} item in your cart` : `${quantity} items in your cart`
      }
    >
      <ButtonText>Cart</ButtonText>
      {quantity > 0 ? <CartIcon /> : <EmptyCartIcon />}
      {quantity > 0 ? <Badge>{quantity}</Badge> : null}
    </StyledLink>
  );
}
